import { Spacing, Text, Title } from '@vkontakte/vkui';
import React, { useEffect } from 'react';
import { isControlFreemium, isHardFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumUnlimitedSpaceModal.css';

interface UnlimitedSpaceModalProps {
    title: string;
    text: string;
}

const UnlimitedSpaceConfig: Array<UnlimitedSpaceModalProps> = [
    {
        title: 'Как работает безлимитная автозагрузка?',
        text: 'Фото и видео с телефона загружаются в Облако, но не занимают память. Сколько бы места ни занимала галерея в телефоне, в Облаке она будет весить 0 ГБ',
    },
    {
        title: 'Где включается безлимитная автозагрузка?',
        text: 'В настройках аккаунта в приложении Облака на телефоне',
    },
    {
        title: 'Как работает безлимитная автозагрузка в семейном тарифе?',
        text: 'У всех участников подписки появится эта возможность. Но у каждого папка для фото и видео с телефона личная. Только вы видите содержимое этой папки',
    },
];

export const FreemiumUnlimitedSpaceModal = ({ onClose }) => {
    const dwhName = isControlFreemium
        ? 'family_unlimited_info_trial'
        : isHardFreemium
        ? 'family_unlimited_info_hard_freemium'
        : 'family_unlimited_info_soft_freemium';

    useEffect(() => {
        sendDwh({
            eventCategory: 'modal',
            action: 'show',
            dwhData: { name: dwhName },
            dwh_enabled: true,
        });
    }, []);

    const onCloseWrapper = () => {
        sendDwh({
            eventCategory: 'modal',
            action: 'close',
            dwhData: { name: dwhName },
            dwh_enabled: true,
        });
        onClose?.();
    };

    return (
        <Dialog open header={''} closable onCancel={onCloseWrapper} className={styles.root}>
            {UnlimitedSpaceConfig.map(({ title, text }, index) => (
                <div key={index}>
                    <Title level="3">{title}</Title>
                    <Spacing size={8} />
                    <Text>{text}</Text>
                </div>
            ))}
        </Dialog>
    );
};
